import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setActiveTab } from 'state/actions/tab';
import Dashboard from 'pages/Dashboard';
import BookingHistory from 'pages/BookingHistory';
import RoomManagement from 'pages/RoomManagement';
import './BookingManagement.css';

const BookingManagement = ({ history }) => {
  const [activeView, setActiveView] = useState('dashboard');
  const [forceRender, setForceRender] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveTab({ tab: 'bookingManagement' }));
  }, [dispatch]);

  const handleViewChange = (viewKey) => {
    setActiveView(viewKey);
    setForceRender((prev) => prev + 1);
  };

  const renderActiveView = () => {
    if (activeView === 'dashboard') {
      return <Dashboard key={`dashboard-${forceRender}`} history={history} />;
    }
    if (activeView === 'bookingHistory') {
      return (
        <BookingHistory
          key={`bookingHistory-${forceRender}`}
          history={history}
        />
      );
    }
    if (activeView === 'roomManagement') {
      return (
        <RoomManagement
          key={`roomManagement-${forceRender}`}
          history={history}
        />
      );
    }
    return <Dashboard key={`default-${forceRender}`} history={history} />;
  };

  return (
    <>
      <div
        className="media-tab-left"
        style={{ padding: '16px 20px 0px 20px', backgroundColor: '#fff' }}
      >
        <div
          onClick={() => handleViewChange('dashboard')}
          className={`media-tab ${activeView === 'dashboard' ? 'active' : ''}`}
        >
          Dashboard
        </div>
        <div
          onClick={() => handleViewChange('bookingHistory')}
          className={`media-tab ${
            activeView === 'bookingHistory' ? 'active' : ''
          }`}
        >
          Booking History
        </div>
        <div
          onClick={() => handleViewChange('roomManagement')}
          className={`media-tab ${
            activeView === 'roomManagement' ? 'active' : ''
          }`}
        >
          Room Management
        </div>
      </div>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        {renderActiveView()}
      </div>
    </>
  );
};

export default BookingManagement;
